import React, {useState} from "react";
import {Grid, Button, Icon, Header, Message, Progress, Modal} from "semantic-ui-react";
import DialogConversationAdder from "./DialogConversationAdder";
import ClassLevelModal from "../../../editComponents/ClassLevelModal";

function AddDialogConversationComponent(
    {
        handleSetDialogConversationData,
        uploadAssignment,
        loading,
        progress,
        progressText,
        error,
        success,
        assignmentLoaded,
        handleDownload,
        replaceAssignment,
        handleDownloadAssignment,
        handleClearData,
        editAssignment,
        assignment
    }
) {

    const tab = <span style={{paddingRight: "30px"}}/>;

    const [open, setOpen] = useState(false);

    return (
        <>
            <Modal
                onClose={() => setOpen(false)}
                onOpen={() => setOpen(true)}
                open={open}
                trigger={<Button color='black' style={{marginTop: 5, marginLeft: 5}}>
                    <Icon name='warning'/>
                    Clear Data
                </Button>}
            >
                <Modal.Header>Clear Data</Modal.Header>
                <Modal.Content image>
                    <Modal.Description>
                        <p>
                            You are attempting to clear the data on this page for any of these reasons:<br/><br/>
                            1. You are finished uploading the assignment and want to add a new one.<br/>
                            2. You made a mistake and would like to restart.<br/>
                            3. You have encountered an error on submitting the assignment and would like to start
                            over.<br/>
                            4. If you are editing an assignment and would like to start from scratch.<br/><br/>
                            <b>Are you sure you want to clear the data on this page?</b>

                        </p>
                    </Modal.Description>
                </Modal.Content>
                <Modal.Actions>
                    <Button color='red' onClick={() => {
                        setOpen(false);
                        handleClearData();
                    }}>
                        Yes
                    </Button>
                    <Button
                        content="No"
                        onClick={() => setOpen(false)}
                    />
                </Modal.Actions>
            </Modal>
            <Grid centered={true} style={{marginBottom: 30}}>
                <Grid.Row>
                    {
                        editAssignment ?
                            <Grid.Row>
                                <Header as='h1'>
                                    You are editing {assignment} in Dialog Exercise
                                </Header>
                            </Grid.Row>
                            :
                            <Header as='h1' style={{color: 'black'}}>
                                Add Dialog Exercise
                            </Header>
                    }

                </Grid.Row>
                <Grid.Row>
                    <Button onClick={handleDownload} color='blue'>Download Directions</Button>
                </Grid.Row>
                {
                    replaceAssignment ?
                        <>
                            <Grid.Row>
                                <Message>
                                    <b>To edit this assignment, download a copy using the button below.</b><br/>
                                    <b>Once you have made your edits, use the input below to replace the current
                                        assignment.</b>
                                </Message>
                            </Grid.Row>
                            <Grid.Row>
                                <Button onClick={handleDownloadAssignment} color='blue'>Download Current
                                    Assignment</Button>
                            </Grid.Row>
                        </>
                        :
                        null
                }


                {/*{*/}
                {/*    showDirections ?*/}
                {/*        <>*/}
                {/*            <Message color='blue'>*/}
                {/*                <Header as='h2' textAlign='left' color='black'>*/}
                {/*                    <h2 style={{color: 'black'}}>*/}
                {/*                        Directions for Constructing Dialog Exercises:*/}
                {/*                    </h2>*/}
                {/*                </Header>*/}
                {/*                <p style={{textAlign: 'left', color: "black"}}>*/}
                {/*                    To create a dialog exercise you will need to create a text file using a text editor (in*/}
                {/*                    Windows you can use Notepad, on the Mac you can use TextEdit.) <br/>*/}
                {/*                    The text file should be named using the suffix .json (for example:*/}
                {/*                    exercise1.json)<br/><br/>*/}
                {/*                    Within this .json file you can create your dialog script that will specify the sequence*/}
                {/*                    of prompts and responses in your dialog.<br/>*/}
                {/*                    A script consists of 4 main components:<br/>*/}
                {/*                    {tab}1. Speaker A’s prompt (in both Samoan and English), (labeled <span className='red'>speakA</span> and*/}
                {/*                    <span className='red'>speakA_eng</span>)<br/>*/}
                {/*                    {tab}2. Speaker B’s responses (in both Samoan and English), (labeled <span className='green'>speakB</span> and*/}
                {/*                    <span className='green'>speakB_eng</span>)<br/>*/}
                {/*                    {tab}3. References to audio files for items 1 and 2 (labeled <span className='blue'>speakA_audio</span> and <span className='blue'>speakB_audio</span> ) .<br/>*/}
                {/*                    {tab}4. Speaker A’s followup responses to Speaker B, (labeled <span className='pink'>followup</span>)<br/><br/>*/}
                {/*                    These components are written into a template such as the following:<br/>*/}
                {/*                    <span className='codeFont'>*/}
                {/*                [<br/>*/}
                {/*                    {tab}{"{"}<br/>*/}
                {/*                    <span className='red'>{tab}{tab} "speakA": "",<br/></span>*/}
                {/*                    <span className='red'> {tab}{tab} "speakA_eng": "",<br/></span>*/}
                {/*                    <span className='green'>    {tab}{tab} "speakB": [],<br/></span>*/}
                {/*                    <span className='green'>{tab}{tab} "speakB_eng": [],<br/></span>*/}
                {/*                    <span className='blue'>{tab}{tab} "speakA_audio": "",<br/></span>*/}
                {/*                     <span className='blue'>   {tab}{tab} "speakB_audio": [],<br/></span>*/}
                {/*                    <span className='pink'>{tab}{tab} "followup": [[]]<br/></span>*/}
                {/*                        {tab}{"}"}<br/>*/}
                {/*                ]<br/><br/>*/}
                {/*        </span>*/}
                {/*                    Let’s use an example to explain how to fill in the template.<br/>*/}
                {/*                    Let’s say we want Speaker A to initiate a dialog with<br/>*/}
                {/*                    {tab}<span className='red'>"ʻO ā mai ʻoe?"</span> which*/}
                {/*                    means <span className='red'>"How are you?"</span><br/>*/}
                {/*                    Speaker Bʻs response might be one of the following:<br/>*/}
                {/*                    {tab}<span className='green'>"Manuia lava faʻafetai” ("Fine thanks")</span> or<br/>*/}
                {/*                    {tab}<span className='green'>"Manuia lava faʻafetai, ʻAe ā ʻoe?” (“Fine thanks, and how about you?”)</span><br/><br/>*/}
                {/*                    To capture this conversation we would write:<br/>*/}
                {/*                    <span className='codeFont'>*/}
                {/*                [<br/>*/}
                {/*                    {tab}{"{"}<br/>*/}
                {/*                        {tab}{tab} <span className='red'>"speakA":"ʻO ā mai ʻoe?”,<br/>*/}
                {/*                        {tab}{tab} "speakA_eng": "How are you?”,</span><br/>*/}
                {/*                        {tab}{tab} <span className='green'>"speakB":["Manuia lava faʻafetai", "Manuia lava faʻafetai, ʻAe ā ʻoe?”]	<br/>*/}
                {/*                        {tab}{tab} "speakB_eng": ["Fine thanks", "Fine thanks, How about you?”],</span><br/>*/}
                {/*                        {tab}{tab} "speakA_audio": "",<br/>*/}
                {/*                        {tab}{tab} "speakB_audio": [ ],<br/>*/}
                {/*                        {tab}{tab} "followup": [ ]<br/>*/}
                {/*                        {tab}{"}"}<br/>*/}
                {/*                ]<br/><br/>*/}
                {/*                </span>*/}
                {/*                    Notice in our example we made one of Speaker Bʻs possible responses as:<br/>*/}
                {/*                    {tab} "Manuia lava faʻafetai, ʻAe ā ʻoe?” (“Fine thanks, and how about you?”)<br/><br/>*/}

                {/*                    This implies that Speaker A would want to follow up with a response to Speaker Bʻs*/}
                {/*                    question.<br/>*/}
                {/*                    Thatʻs where filling in the followup section comes in.<br/>*/}
                {/*                    Recall that Speaker B had 2 possible responses:<br/>*/}
                {/*                    {tab}1. "Manuia lava faʻafetai” ("Fine thanks") <br/>*/}
                {/*                    {tab}2. "Manuia lava faʻafetai, ʻAe ā ʻoe?” (“Fine thanks, and how about you?”)<br/><br/>*/}

                {/*                    We donʻt expect Speaker A to follow up with a response to "Manuia faʻafetai” ("Fine thanks")<br/>*/}
                {/*                    but we do expect Speaker A to follow up with a response to "Manuia lava faʻafetai, ʻAe ā ʻoe?” (“Fine thanks, and how about you?”).<br/><br/>*/}
                {/*                    So in the followup section we would write 2 series of square brackets like this:<br/>*/}
                {/*                    {tab}<span className='codeFont'><span*/}
                {/*                    className='pink'> "followup": [[ ], [ ]]</span></span><br/><br/>*/}

                {/*                    The first set of square brackets <span className='codeFont'><span*/}
                {/*                    className='pink'> [ ]</span></span> are left empty because there will be no followup*/}
                {/*                    response for Speaker A.<br/>*/}
                {/*                    However we want to provide a followup response for "Manuia lava faʻafetai, ʻAe ā ʻoe?” (“Fine thanks, and how about you?”).<br/>*/}
                {/*                    In this example weʻll make that followup response “Manuia foʻi faʻafetai” (Fine also, thanks).<br/><br/>*/}
                {/*                    So we need to fill in the second set of square brackets as shown below in purple.<br/>*/}
                {/*                    <span className='codeFont'>*/}
                {/*                [<br/>*/}
                {/*                    {tab}{"{"}<br/>*/}
                {/*                        {tab}{tab} speakA": "ʻO ā mai ʻoe?”,<br/>*/}
                {/*                        {tab}{tab} "speakA_eng": "How are you?”,<br/>*/}
                {/*                        {tab}{tab} speakB": ["Manuia faʻafetai", "Manuia lava faʻafetai, ʻAe ā ʻoe?”],<br/>*/}
                {/*                        {tab}{tab} "speakB_eng": ["Fine thanks", "Fine thanks, How about you?”],<br/>*/}
                {/*                        {tab}{tab} "speakA_audio": "",<br/>*/}
                {/*                        {tab}{tab} "speakB_audio": [ ],<br/>*/}
                {/*                        {tab}{tab} <span className='pink'>“followup”: [<br/>*/}
                {/*                        {tab}{tab}{tab} [ ]</span>,  <span className='orange'>←  this is left as a [ ] to indicate that no response is expected for "Manuia lava faʻafetai”</span><br/>*/}
                {/*                        {tab}{tab}{tab}<span className='pink'>[<br/>*/}
                {/*                        {tab}{tab}{tab}{tab}{"{"}<br/>*/}
                {/*                        {tab}{tab}{tab}{tab} "speakA": "Manuia foʻi faʻafetai",<br/>*/}
                {/*                        {tab}{tab}{tab}{tab} "speakB": [ ],<br/>*/}
                {/*                        {tab}{tab}{tab}{tab} "speakA_eng": "Fine also, thanks”,<br/>*/}
                {/*                        {tab}{tab}{tab}{tab} "speakB_eng": [ ],<br/>*/}
                {/*                        {tab}{tab}{tab}{tab} "speakA_audio": "",<br/>*/}
                {/*                        {tab}{tab}{tab}{tab} "speakB_audio": [ ],<br/>*/}
                {/*                        {tab}{tab}{tab}{tab} “followup”: [ ]<br/>*/}
                {/*                        {tab}{tab}{tab}{tab}{"}"}<br/>*/}
                {/*                        {tab}{tab}{tab}]<br/>*/}
                {/*                        {tab}{tab} ]<br/></span>*/}
                {/*                        {tab}{"}"}<br/>*/}
                {/*                ]<br/><br/>*/}
                {/*                </span>*/}
                {/*                    To sum up about <span className='pink'>“followup”</span>, it is a way to followup a*/}
                {/*                    dialog after Speaker B’s response.<br/>*/}
                {/*                    In this example the first <span className='pink'>“followup”</span> statement is marked*/}
                {/*                    as <span className='codeFont'><span className='pink'>[ ]</span></span> which means that*/}
                {/*                    there will be no followup response.<br/>*/}
                {/*                    In essence the conversation has ended.<br/><br/>*/}

                {/*                    Lastly there are two fields that still need to be explained:<br/>*/}
                {/*                    {tab}<span className='codeFont'><span className='blue'>"speakA_audio": "",<br/>*/}
                {/*                    {tab}"speakB_audio": [ ],</span></span><br/><br/>*/}

                {/*                    <b>speakA_audio</b> refers to the name of the audio file for Speaker A’s initial*/}
                {/*                    question prompt which was<br/>*/}
                {/*                    {tab}ʻO ā mai ʻoe?”.<br/>*/}
                {/*                    <b>speakB_audio</b> refers to the name of the audio files for Speaker B’s*/}
                {/*                    responses.<br/>*/}
                {/*                    {tab}If for example, the audio file for "ʻO ā mai ʻoe?” is <span className='blue'>oamai.mp3</span>,*/}
                {/*                    and<br/>*/}
                {/*                    {tab}the audio file for “Manuia faʻafetai” is <span className='blue'>manuia.mp3</span>,*/}
                {/*                    and<br/>*/}
                {/*                    {tab}the audio file for "Manuia lava faʻafetai, ʻAe ā ʻoe?” is <span*/}
                {/*                    className='blue'>manuiaeaoe.mp3</span>, and<br/>*/}
                {/*                    {tab}the audio file for "Manuia foʻi faʻafetai", is <span*/}
                {/*                    className='blue'>“thanks.mp3”</span><br/>*/}
                {/*                    {tab}then we would insert them into our script as shown in blue below.<br/>*/}
                {/*                    <span className='codeFont'>*/}
                {/*                [<br/>*/}
                {/*                    {tab}{"{"}<br/>*/}
                {/*                        {tab}{tab}"speakA": "ʻO ā mai ʻoe?”,<br/>*/}
                {/*                        {tab}{tab}"speakA_eng": "How are you?”,<br/>*/}
                {/*                        {tab}{tab}"speakB": ["Manuia lava faʻafetai", "Manuia lava faʻafetai, ʻAe ā ʻoe?”],<br/>*/}
                {/*                        {tab}{tab}"speakB_eng": ["Fine thanks", "Fine thanks, How about you?”],<br/>*/}
                {/*                        {tab}{tab}<span className='blue'>"speakA_audio": "oamai.mp3",<br/>*/}
                {/*                        {tab}{tab}"speakB_audio": [“manuia.mp3”,”manuiaeaoe.mp3”]</span>,<br/>*/}
                {/*                        {tab}{tab}“followup”: [<br/>*/}
                {/*                        {tab}{tab}{tab}[ ],<br/>*/}
                {/*                        {tab}{tab}{tab}[<br/>*/}
                {/*                        {tab}{tab}{tab}{tab}{"{"}<br/>*/}
                {/*                        {tab}{tab}{tab}{tab}{tab}"speakA": "Manuia foʻi faʻafetai",<br/>*/}
                {/*                        {tab}{tab}{tab}{tab}{tab}"speakA_eng": "Fine also, thanks”,<br/>*/}
                {/*                        {tab}{tab}{tab}{tab}{tab}"speakB": [ ],<br/>*/}
                {/*                        {tab}{tab}{tab}{tab}{tab}"speakB_eng": [ ],<br/>*/}
                {/*                        {tab}{tab}{tab}{tab}{tab}<span className='blue'>"speakA_audio": "thanks.mp3",<br/>*/}
                {/*                        {tab}{tab}{tab}{tab}{tab}"speakB_audio": [ ],</span><br/>*/}
                {/*                        {tab}{tab}{tab}{tab}{tab}“followup”: [[]]<span className='orange'> ←  this is left as a [ ] to indicate the end of the dialog</span><br/>*/}
                {/*                        {tab}{tab}{tab}{tab}{"}"}<br/>*/}
                {/*                        {tab}{tab}{tab}]<br/>*/}
                {/*                        {tab}{tab}]<br/>*/}
                {/*                        {tab}{"}"}<br/>*/}
                {/*                ]<br/><br/>*/}
                {/*                </span>*/}
                {/*                    <b> Multiple Prompt/Question Choices for Speaker A</b><br/>*/}

                {/*                    So far our example has provided only a single choice for Speaker A.<br/>*/}
                {/*                    However for any given dialog, Speaker A may well have more than one possible prompt / question.<br/>*/}
                {/*                    Let’s take a look at the following example that provides multiple choices for speaker A.<br/><br/>*/}

                {/*                    Letʻs say, Speaker A could initiate the conversation with either:<br/>*/}
                {/*                    {tab}<span className='red'> "ʻO ā mai ʻoe?"</span> which means <span className='red'>"How are you?"</span><br/>*/}
                {/*                    {tab}<span className='red'>"Sole ua?”</span> which means <span className='red'> “Dude whatʻs up?”</span><br/><br/>*/}

                {/*                    We would write:<br/>*/}
                {/*                    <span className='codeFont'>*/}
                {/*                [<br/>*/}
                {/*                    {tab}{"{"}<br/>*/}
                {/*                        {tab}{tab}<span className='red'>"speakA": "ʻO ā mai ʻoe?",<br/>*/}
                {/*                        {tab}{tab}"speakA_eng": "How are you?",</span><br/>*/}
                {/*                        {tab}{tab}"speakB": [ ],<br/>*/}
                {/*                        {tab}{tab}"speakB_eng": [ ],<br/>*/}
                {/*                        {tab}{tab}"speakA_audio": "",<br/>*/}
                {/*                        {tab}{tab}"speakB_audio": [ ],<br/>*/}
                {/*                        {tab}{tab}"followup": [ ]<br/>*/}
                {/*                    {tab}{"}"},<br/>*/}
                {/*                        {tab}{"{"}<br/>*/}
                {/*                        {tab}{tab}<span className='red'>""speakA": "Sole ua?",<br/>*/}
                {/*                        {tab}{tab}"speakA_eng": "Dude whatʻs up",</span><br/>*/}
                {/*                        {tab}{tab}"speakB": [ ],<br/>*/}
                {/*                        {tab}{tab}"speakB_eng": [ ],<br/>*/}
                {/*                        {tab}{tab}"speakA_audio": "",<br/>*/}
                {/*                        {tab}{tab}"speakB_audio": [ ],<br/>*/}
                {/*                        {tab}{tab}"followup": [ ]<br/>*/}
                {/*                    {tab}{"}"}<br/>*/}
                {/*                        ]<br/><br/>*/}
                {/*                </span>*/}
                {/*                    This would result in speaker A having two options to initiate the conversation with,<br/>*/}
                {/*                    and depending on what speaker A decides to ask, could initiate a corresponding response.<br/><br/>*/}

                {/*                    For example, Speaker B may want to respond to “O ā mai ʻoe?” with<br/>*/}
                {/*                    {tab}<span className='green'> “Maunia lava faʻafetai”</span> which means <span className='green'>“Fine thanks”</span><br/>*/}
                {/*                    Or he/she may respond to Sole ua” with<br/>*/}
                {/*                    {tab}<span className='green'>“Leai se mea”</span> which means <span className='green'>“Nothing”</span><br/><br/>*/}

                {/*                    We would write:<br/>*/}
                {/*                    <span className='codeFont'>*/}
                {/*                [<br/>*/}
                {/*                    {tab}{"{"}<br/>*/}
                {/*                        {tab}{tab}"speakA": "ʻO ā mai ʻoe?",<br/>*/}
                {/*                        {tab}{tab}   "speakA_eng": "How are you?",<br/>*/}
                {/*                        {tab}{tab}<span className='green'>"speakB": [“Maunia lava faʻafetai”],<br/>*/}
                {/*                        {tab}{tab}   "speakB_eng": [“Fine thanks” ],</span><br/>*/}
                {/*                        {tab}{tab}    "speakA_audio": "",<br/>*/}
                {/*                        {tab}{tab}   "speakB_audio": [ ],<br/>*/}
                {/*                        {tab}{tab}   "followup": [ ]<br/>*/}
                {/*                        {tab}{"}"},<br/>*/}
                {/*                        {tab}{"{"}<br/>*/}
                {/*                        {tab}{tab}"speakA": "Sole ua?”,<br/>*/}
                {/*                        {tab}{tab}   "speakA_eng": "Dude whatʻs up?",<br/>*/}
                {/*                        {tab}{tab}<span className='green'>"speakB": [“Leai se mea” ],<br/>*/}
                {/*                        {tab}{tab}    "speakB_eng": [“Nothing”],</span><br/>*/}
                {/*                        {tab}{tab}   "speakA_audio": "",<br/>*/}
                {/*                        {tab}{tab}    "speakB_audio": [ ],<br/>*/}
                {/*                        {tab}{tab}   "followup": [ ]<br/>*/}
                {/*                        {tab}{"}"}<br/>*/}
                {/*                    ]<br/><br/>*/}
                {/*                </span>*/}
                {/*                    Next, we can fill in the audio files for <b>speakA_audio</b> and <b>speakB_audio</b><br/><br/>*/}
                {/*                    We have the audio files:<br/>*/}
                {/*                    {tab}"ʻO ā mai ʻoe?"named <span className='blue'>"oaimai.mp3"</span><br/>*/}
                {/*                    {tab}"Sole ua?" named <span className='blue'>"soleua.mp3"</span><br/>*/}
                {/*                    {tab}"Maunia lava faʻafetai" named <span className='blue'>"maunialava.mp3"</span><br/>*/}
                {/*                    {tab} and "Leai se mea" named <span className='blue'>"leai.mp3"</span><br/><br/>*/}
                {/*                    We can write these names in like so<br/>*/}
                {/*                    <span className='codeFont'>*/}
                {/*                [<br/>*/}
                {/*                    {tab}{"{"}<br/>*/}
                {/*                        {tab}{tab}"speakA": "ʻO ā mai ʻoe?",<br/>*/}
                {/*                        {tab}{tab}   "speakA_eng": "How are you?",<br/>*/}
                {/*                        {tab}{tab}"speakB": [“Maunia lava faʻafetai”],<br/>*/}
                {/*                        {tab}{tab}   "speakB_eng": [“Fine thanks” ],<br/>*/}
                {/*                        {tab}{tab}    <span className='blue'> "speakA_audio": "oaimai.mp3",<br/>*/}
                {/*                        {tab}{tab}   "speakB_audio": ["maunialava.mp3"],</span><br/>*/}
                {/*                        {tab}{tab}   "followup": [ ]<br/>*/}
                {/*                        {tab}{"}"},<br/>*/}
                {/*                        {tab}{"{"}<br/>*/}
                {/*                        {tab}{tab}"speakA": "Sole ua?”,<br/>*/}
                {/*                        {tab}{tab}   "speakA_eng": "Dude whatʻs up?",<br/>*/}
                {/*                        {tab}{tab}"speakB": [“Leai se mea” ],<br/>*/}
                {/*                        {tab}{tab}    "speakB_eng": [“Nothing”],<br/>*/}
                {/*                        {tab}{tab}   <span className='blue'> "speakA_audio": "soleua.mp3",<br/>*/}
                {/*                        {tab}{tab}    "speakB_audio": ["leai.mp3"],</span><br/>*/}
                {/*                        {tab}{tab}   "followup": [ ]<br/>*/}
                {/*                    {tab}{"}"}<br/>*/}
                {/*                        ]<br/><br/>*/}
                {/*                </span>*/}
                {/*                    Lastly, When speaker A has nothing to respond to speaker B with, we can end the conversation.<br/>*/}
                {/*                    In order to end the conversation, we need to add <span className='pink'><span className='codeFont'>[]</span></span> in the followup section.<br/>*/}
                {/*                    We would finish the dialog by writing<br/>*/}
                {/*                    <span className='codeFont'>*/}
                {/*                [<br/>*/}
                {/*                    {tab}{"{"}<br/>*/}
                {/*                        {tab}{tab}"speakA": "ʻO ā mai ʻoe?",<br/>*/}
                {/*                        {tab}{tab}   "speakA_eng": "How are you?",<br/>*/}
                {/*                        {tab}{tab}"speakB": [“Maunia lava faʻafetai”],<br/>*/}
                {/*                        {tab}{tab}   "speakB_eng": [“Fine thanks” ],<br/>*/}
                {/*                        {tab}{tab}    "speakA_audio": "oaimai.mp3",<br/>*/}
                {/*                        {tab}{tab}   "speakB_audio": ["maunialava.mp3"],<br/>*/}
                {/*                        {tab}{tab}   <span className='pink'>"followup": [[]]</span><br/>*/}
                {/*                        {tab}{"}"},<br/>*/}
                {/*                        {tab}{"{"}<br/>*/}
                {/*                        {tab}{tab}"speakA": "Sole ua?”,<br/>*/}
                {/*                        {tab}{tab}   "speakA_eng": "Dude whatʻs up?",<br/>*/}
                {/*                        {tab}{tab}"speakB": [“Leai se mea” ],<br/>*/}
                {/*                        {tab}{tab}    "speakB_eng": [“Nothing”],<br/>*/}
                {/*                        {tab}{tab}   "speakA_audio": "soleua.mp3",<br/>*/}
                {/*                        {tab}{tab}    "speakB_audio": ["leai.mp3"],<br/>*/}
                {/*                        {tab}{tab}   <span className='pink'>"followup": [[]]</span><br/>*/}
                {/*                        {tab}{"}"}<br/>*/}
                {/*                        ]<br/><br/>*/}
                {/*                </span>*/}
                {/*                    <b>Greetings and Goodbyes</b><br/>*/}

                {/*                    Greetings “Talofa”, “Malo”, and “Malo le soifua” are automatically incorporated into each dialog exercise so you do not need to write these into the file.<br/>*/}
                {/*                    Goodbyes “Tofa soifua”, “Tofa”, and “Fa” are also automatically incorporated when the dialog has reached its end so do not include write these into the file either.<br/>*/}

                {/*                </p>*/}

                {/*            </Message>*/}
                {/*        </>*/}
                {/*        :*/}
                {/*        null*/}

                {/*}*/}

                <Grid.Row>
                    <DialogConversationAdder
                        handleSetDialogConversationData={handleSetDialogConversationData}
                    />
                </Grid.Row>
                {
                    success ?
                        <Grid.Row>
                            <Message positive>
                                <Message.Header>Assignment has been uploaded to the Dialog Conversation Page
                                    page</Message.Header>
                            </Message>
                        </Grid.Row>
                        :
                        null
                }
                {
                    error ?
                        <Grid.Row>
                            <Message negative>
                                <Message.Header>{error}</Message.Header>
                            </Message>
                        </Grid.Row>
                        :
                        null
                }
                {
                    loading ?
                        <Grid.Row>
                            <Progress style={{width: 400}} indicating progress percent={progress}>
                                {progressText}
                            </Progress>
                        </Grid.Row>
                        :
                        success ?
                            <Grid.Row>
                                <br/>
                                <Button color='green' disabled={true} onClick={uploadAssignment}>Upload
                                    Assignment</Button>
                            </Grid.Row>
                            :
                            assignmentLoaded ?
                                <Grid.Row>
                                    <br/>
                                    <Button color='green' onClick={uploadAssignment}>Upload Assignment</Button>
                                </Grid.Row>
                                :
                                <Grid.Row>
                                    <br/>
                                    <Button color='green' disabled onClick={uploadAssignment}>Upload Assignment</Button>
                                </Grid.Row>
                }
            </Grid>
        </>
    )
}

export default AddDialogConversationComponent
